/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    IAccountProfileEditItem,
    IAccountProfileEditLoading,
    IAccountProfileEditLocalAccount,
    IAccountProfileEditViewProps
} from './account-profile-edit';

const AccountProfileEditItem: React.FC<IAccountProfileEditItem> = ({ wrapper, label, errorMessage, input }) => {
    return (
        <Node {...wrapper}>
            {label}
            {errorMessage}
            {input}
        </Node>
    );
};

const LocalAccount: React.FC<IAccountProfileEditLocalAccount> = ({
    localAccount,
    items,
    errorMessage,
    buttonsWrapper,
    buttons,
    verificationSuccessModal,
    verificationSuccessModalMessage
}) => {
    return (
        <Node {...localAccount}>
            {items &&
                items.map((item: IAccountProfileEditItem) => {
                    // eslint-disable-next-line react/jsx-key
                    return <AccountProfileEditItem {...item} />;
                })}
            {errorMessage &&
                errorMessage.map((error: React.ReactNode, index: number) => {
                    return <React.Fragment key={index}>{error}</React.Fragment>;
                })}
            <Node {...buttonsWrapper}>
                {buttons &&
                    buttons.map((button: React.ReactNode, index: number) => {
                        return <React.Fragment key={index}>{button}</React.Fragment>;
                    })}
            </Node>

            <Node {...verificationSuccessModal}>
                <Node {...verificationSuccessModalMessage} />
            </Node>
        </Node>
    );
};

const AccountProfileEditLoading: React.FC<IAccountProfileEditLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const AccountProfileEditView: React.FC<IAccountProfileEditViewProps> = props => {
    const { accountProfileEdit, viewState, loading, defaultAADConainer, aadConainer, heading, accountProfileEditLocalAccount } = props;

    return (
        <Module {...accountProfileEdit}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <AccountProfileEditLoading {...loading} />}
            <Node {...aadConainer}>
                {heading}
                {LocalAccount(accountProfileEditLocalAccount)}
            </Node>
        </Module>
    );
};

export default AccountProfileEditView;
